const ROOT = 'AGENCY_WORKERS';

const actionTypes = {
  LOAD_LIST_DATA: `${ROOT}_LOAD_LIST_DATA`,
  LOAD_LIST_DATA_SUCCESS: `${ROOT}_LOAD_LIST_DATA_SUCCESS`,
  LOAD_LIST_DATA_ERROR: `${ROOT}_LOAD_LIST_DATA_ERROR`,
  CLEAR_STORE: `${ROOT}_CLEAR_STORE`,
} as const;

export default actionTypes;
